
import { clientPageMixin } from '@/mixins'

import foFooter from '@/components/footer/footer.vue'
import foHeader from '@/components/header/header.vue'
import timelineTracking from '@/components/timelineTracking/timelineTracking.vue'

import { MAX_DISPLAYED_CHIPS, ROUTES } from '@/constants'
import { dateHelper } from '@/helpers/dateHelper'
import { Delivery, SelectItem, StatusItem, StatusItemVue } from '@/types'

import { AdapterFactory } from '@/adapter/adapter.factory'
import TimelineTrackingService from '@/services/timelineTacking/timelineTracking.service'
import mixins from 'vue-typed-mixins'

export default mixins(clientPageMixin).extend({
  name: 'mp-tracking',
  components: {
    foFooter,
    foHeader,
    timelineTracking,
  },
  data() {
    return {
      dateHelper,
      selectedStatus: [] as Array<StatusItemVue | null>,
      activeChipIndex: -1,
      MAX_DISPLAYED_CHIPS,
      hasLoaded: false,
    }
  },
  computed: {
    selectItemsList(): SelectItem[] {
      if (!this.delivery) {
        return []
      }

      const selectItems: SelectItem[] = [{ value: 0, text: this.$t('tracking.allOrders') }]

      selectItems.push(
        ...this.delivery.packages.map((localPackage, index) => {
          return {
            ...localPackage,
            value: index + 1,
            text: this.$t('tracking.package', { number: index + 1 }),
          }
        }),
      )

      return selectItems
    },
    deliveryHasTrackingPageUrl(): boolean {
      const { trackingPageUrl } = (this.delivery as unknown) as Delivery

      const displayTracking = this.clientPage?.config.carrierInfos?.followDelivery
      return Boolean(displayTracking && trackingPageUrl)
    },
  },
  async beforeMount() {
    const {
      query: { language },
    } = this.$route

    const languageToUse = language?.toString()

    await this.getClientPage(languageToUse)

    if (!this.clientPage || !this.delivery) {
      return this.$router.push({ name: ROUTES.NOT_FOUND })
    }

    this.activeChipIndex = 0

    this.hasLoaded = true
  },
  methods: {
    getStatus(status: StatusItem[]): void {
      this.selectedStatus = TimelineTrackingService.getStatus(status, this.delivery?.order.services)
    },
    goToTrackingUrl(): void {
      const { trackingPageUrl } = (this.delivery as unknown) as Delivery

      if (trackingPageUrl) {
        window.open(trackingPageUrl)
      }
    },
    goToClaimUrl(): void {
      const {
        carrier: { claimUrl },
      } = (this.delivery as unknown) as Delivery

      if (claimUrl) {
        window.open(claimUrl)
      }
    },
  },
  watch: {
    activeChipIndex(next) {
      if (this.delivery) {
        if (next === 0) {
          this.getStatus(this.delivery.deliveryStatus)
        } else {
          this.getStatus(this.delivery.packages[next - 1].status)
        }

        if (this.delivery.carrier.code) {
          const adapter = AdapterFactory.create(this.delivery.carrier.code)

          if (!adapter) {
            return
          }

          const trackingPageUrl = adapter.buildTrackingPageUrl(this.delivery, next)
          this.delivery.trackingPageUrl = trackingPageUrl
        }
      }
    },
  },
})
